// extracted by css-extract-rspack-plugin
export default {"GroupedHeading":"FlexSuiteOutroFaqs-module__GroupedHeading__Lz9bG"};